module.exports = __webpack_public_path__ + "static/media/logo-navbar.4b57dcda.svg";